import { config } from "./Constants";
import CryptoJS from "crypto-js";

export const encrypt = (plainText) => {
  let cypher = CryptoJS.AES.encrypt(plainText, config.SECRET);
  return cypher;
};

export const decrypt = (cypher) => {
  if (cypher) {
    const bytes = CryptoJS.AES.decrypt(cypher, config.SECRET);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  return null;
};
